<template>
    <div class="m-listingitem">
        <div class="e-image" v-if="!hideImage">
            <a :href="resultItem.Link.Url" class v-if="resultItem.Link">
                <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
            </a>
        </div>
        <div class="e-text full">
            <div class="top">
                <p v-if="resultItem.DocType=='report'" class="contentcategory">Report</p>

                <p v-if="resultItem.DocType=='product' || resultItem.Link.Url.indexOf('/support/') === 0" class="contentcategory">Support</p>

                <h3>
                    <a :href="resultItem.Link.Url" class v-if="resultItem.Link">{{resultItem.Heading}}</a>
                </h3>

                <p v-if="resultItem.DocType=='report'"><strong>{{formatDate(resultItem.Date.DateTime)}}</strong></p>

                <p :title="resultItem.Summary">{{truncate(resultItem.Summary)}}</p>
            </div>

            <div class="buttons myhie">
                <a :href="resultItem.Link.Url" class="btn btn-green" v-if="resultItem.Link">Find out more</a>
                <profile-actions :page-id="resultItem.Id.toString()"
                                 v-if="resultItem.DocType=='event'
                                 || resultItem.DocType=='newsArticle'
                                 || resultItem.DocType=='gateway'
                                 || resultItem.DocType=='report'
                                 || resultItem.DocType=='product'
                                 || resultItem.DocType=='property'">
                </profile-actions>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    import { truncate } from '@/utils/strings.js'
    import { format, toDate } from '@/utils/date.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
        }
    }
</script>